import React from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/UserProfile.css"; // make sure path matches your project

const UserProfile = () => {
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("active-user"));

  if (!user) {
    return (
      <div className="auth-background">
        <div className="container mt-5">
          <div className="alert alert-warning text-center">
            Please login to view your profile.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-background py-4">
      <div className="container">
        <div className="profile-card shadow-lg">
          <div className="profile-header d-flex align-items-center justify-content-between">
            <div>
              <h2 className="mb-0">User Profile</h2>
              <div className="small text-muted">
                Manage your account details
              </div>
            </div>

            <div className="header-actions">
              {/* <button
                className="btn btn-outline-light btn-sm me-2"
                onClick={goToEdit}
              >
                Edit Profile
              </button> */}
              {/* <button
                className="btn btn-light btn-sm logout-btn"
                onClick={handleLogout}
              >
                Logout
              </button> */}
            </div>
          </div>

          <div className="profile-body p-4">
            <div className="row gx-4 align-items-center">
              <div className="col-md-3 text-center">
                <div className="avatar-wrapper mx-auto mb-2">
                  {/* fallback avatar with initials */}
                  {user.firstName || user.lastName ? (
                    <div className="avatar-initials">
                      {(user.firstName || "U").charAt(0).toUpperCase()}
                      {(user.lastName || "").charAt(0).toUpperCase()}
                    </div>
                  ) : (
                    <img
                      src="/assets/default-avatar.png"
                      alt="avatar"
                      className="avatar-img"
                    />
                  )}
                </div>

                <div className="mt-2">
                  <div className="fw-600">{`${user.firstName || ""} ${
                    user.lastName || ""
                  }`}</div>
                  <div className="small text-muted">
                    {user.role || "Customer"}
                  </div>
                </div>
              </div>

              <div className="col-md-9">
                <div className="row">
                  <div className="col-sm-6 mb-3">
                    <div className="label">Email</div>
                    <div className="value">{user.emailId || "-"}</div>
                  </div>

                  <div className="col-sm-6 mb-3">
                    <div className="label">Phone</div>
                    <div className="value">{user.phoneNo || "-"}</div>
                  </div>

                  <div className="col-sm-6 mb-3">
                    <div className="label">Full Name</div>
                    <div className="value">{`${user.firstName || ""} ${
                      user.lastName || ""
                    }`}</div>
                  </div>

                  <div className="col-sm-6 mb-3">
                    <div className="label">Registered As</div>
                    <div className="value">{user.role || "-"}</div>
                  </div>
                </div>

                {/* Address block (if available) */}
                {user.address ||
                (user.deliveryAddresses &&
                  user.deliveryAddresses.length > 0) ? (
                  <div className="mt-3">
                    <h6 className="mb-2">Address</h6>

                    {user.address ? (
                      <div className="address-card p-3 mb-2">
                        <div className="small text-muted">
                          {user.address.street}
                        </div>
                        <div className="small text-muted">
                          {user.address.city}, {user.address.pincode}
                        </div>
                      </div>
                    ) : null}

                    {/* delivery addresses if present */}
                    {user.deliveryAddresses &&
                      user.deliveryAddresses.length > 0 && (
                        <div className="d-flex gap-2 flex-wrap">
                          {user.deliveryAddresses.map((a) => (
                            <div key={a.id} className="address-pill p-2">
                              <div className="small text-muted">
                                {a.downtown}
                              </div>
                              <div className="small">{a.city}</div>
                            </div>
                          ))}
                        </div>
                      )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <div className="profile-footer p-3 text-muted small text-end">
            <div>
              Profile last updated:{" "}
              {user.updatedAt
                ? new Date(Number(user.updatedAt)).toLocaleString()
                : "-"}
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default UserProfile;
